import { useCallback } from "react"
import {
  Button,
  HeadingLarge,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useNavigate } from "@tanstack/react-router"

import { setOpenModal, useDappDispatch } from "#/redux-state"
import { routes } from "#/shared/constants"
import { MarketItemDetailsLayout } from "#/ui/Market/MarketItemDetails/components"

export default function MarketDonationDetailsSuccess({
  transactionHash,
  image,
  successMessage,
}: {
  transactionHash: string
  image: string
  successMessage: string
}) {
  const navigate = useNavigate()

  const [, theme] = useStyletron()
  const dispatch = useDappDispatch()

  const viewTransactionCallback = useCallback(async () => {
    dispatch(
      setOpenModal("transaction-details", {
        transactionHash,
      }),
    )
  }, [dispatch, transactionHash])

  return (
    <MarketItemDetailsLayout
      isSuccessPage
      image={image}
      overrides={{
        ContentContainer: { Block: { style: { alignItems: "center" } } },
      }}
    >
      <HeadingLarge marginBottom={theme.sizing.scale800}>
        Donation successful!
      </HeadingLarge>
      <ParagraphLarge marginBottom={theme.sizing.scale600}>
        {successMessage}
      </ParagraphLarge>
      <Button
        kind="secondary"
        overrides={{
          BaseButton: {
            style: {
              width: "100%",
              marginBottom: theme.sizing.scale600,
            },
          },
        }}
        onClick={viewTransactionCallback}
      >
        View transaction
      </Button>
      <Button
        kind="secondary"
        overrides={{
          BaseButton: {
            style: {
              width: "100%",
              marginBottom: theme.sizing.scale600,
            },
          },
        }}
        onClick={async () => {
          await navigate({ to: `${routes.MARKET}` })
        }}
      >
        Back to Market
      </Button>
    </MarketItemDetailsLayout>
  )
}
